import React from "react";
import { Link } from "react-router-dom";

const COOKIE_NAME = "ppc_cookie_notice_ack";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 180;

function hasCookie(name) {
  if (typeof document === "undefined") {
    return false;
  }

  return document.cookie
    .split(";")
    .map((item) => item.trim())
    .some((item) => item.startsWith(`${name}=`));
}

function setCookie(name, value, maxAge) {
  if (typeof document === "undefined") {
    return;
  }

  let cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;

  if (window.location.protocol === "https:") {
    cookie += "; Secure";
  }

  document.cookie = cookie;
}

export default function CookieBanner() {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    setIsVisible(!hasCookie(COOKIE_NAME));

    function handleOpenBanner() {
      setIsVisible(true);
    }

    window.addEventListener("ppc:open-cookie-banner", handleOpenBanner);

    return () => {
      window.removeEventListener("ppc:open-cookie-banner", handleOpenBanner);
    };
  }, []);

  function acknowledgeCookies() {
    setCookie(COOKIE_NAME, "1", COOKIE_MAX_AGE);
    setIsVisible(false);
  }

  if (!isVisible) {
    return null;
  }

  return (
    // Bandeau volontairement COMPACT : il flotte au-dessus du contenu (et de la
    // barre d'appel fixe, d'ou bottom-20). Chaque pixel de hauteur est un pixel
    // de page rendu incliquable tant que le visiteur n'a pas repondu. Le detail
    // reglementaire (nom du cookie, finalite, duree, base legale) vit dans
    // /politique-confidentialite : ne pas le recopier ici.
    <div className="fixed inset-x-0 bottom-20 z-50 px-3 lg:bottom-6 lg:px-4">
      <div className="mx-auto max-w-5xl rounded-sm border border-white/10 bg-primary text-white shadow-2xl">
        <div className="flex flex-col gap-3 p-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:p-4">
          <p className="text-xs leading-snug text-slate-200 sm:text-sm">
            Ce site utilise uniquement des cookies strictement nécessaires à son
            fonctionnement.{" "}
            <Link
              to="/politique-confidentialite"
              className="font-semibold text-secondary underline underline-offset-2 hover:text-secondary/80"
            >
              En savoir plus
            </Link>
          </p>

          <button
            type="button"
            onClick={acknowledgeCookies}
            className="shrink-0 self-end rounded-sm bg-secondary px-4 py-2 text-xs font-bold uppercase tracking-wider text-white transition-all hover:bg-secondary/90 active:scale-95 sm:self-auto sm:px-5 sm:py-2.5 sm:text-sm"
          >
            J&apos;ai compris
          </button>
        </div>
      </div>
    </div>
  );
}
